import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import DatePicker from 'react-datepicker'
import { ajaxGet } from '../../../../ajax'

const Preview = props => {
  const { league, duration, games, setGames, fields, setFields, teams, setTeams, rounds, setRounds, setAlert, onPrevStep, onLoading } = props

  const [control, setControl] = useState({})
  const [times, setTimes] = useState([])

  useEffect(() => {
    loadGamesPreviews()
  }, [])

  const loadGamesPreviews = async () => {
    onLoading(true)
    const response = await ajaxGet(`/admins/leagues/${league.id}/schedule.json`)
    const json     = await response.json()
    onLoading(false)

    if (json.alert) setAlert(json.alert)
    else {
      setGames(json.games.map(g => { return {...g, checked: false} }))
      setFields(json.fields)
      setTeams(json.teams)
      setRounds([...(new Set(json.games.map(x => x.round)))].sort())
    }
  }

  const loadTimeslots = async game => {
    const {field_id, date} = game
    const url = `/admins/leagues/${league.id}/schedule/slots.json?field_id=${field_id}&date=${date}`

    const response = await ajaxGet(url)
    const json     = await response.json()

    const booked    = without(game.key).filter(g => g.date == date && g.field_id == field_id).map(g => g.time)
    const available = json.timeslots.filter(t => !booked.some(b => cross(date, b, t)))

    setTimes(available)
  }

  const diff = (date, time, slot) => clock(date, time).diff(clock(date, slot), 'minutes')

  const cross = (date, time, slot) => diff(date, time, slot) - duration + 1 <= 0 && duration + diff(date, time, slot) > 0

  const clock = (date, time) => {
    const point = moment(`${date} ${time}`, 'YYYY-MM-DD h:mm a')

    return point.hours() < 6 ? point.add(1, 'days') : point
  }

  const possible = (game, change) => {
    const changed = {...game, ...change}
    const {date, time, field_id} = changed
    const overlap = without(game).find(g => g.field_id == field_id &&
      Math.abs(clock(g.date, g.time).diff(clock(date, time), 'minutes')) < duration)

    if (overlap) setAlert({text: `Field ${field_id} is already taken on ${date} at ${time}`, type: 'alert'})

    return !overlap
  }

  const imageUrl = team => !team.photo ? '/images/leagues/team.png' : team.photo + '?' + Math.random()

  const without = key => games.filter(g => g.key != key)

  const order = arr => arr.sort((a, b) => a.key - b.key)

  const updateGames = (game, change) =>
    possible(game, change) && (setControl({}) || setGames(order([...without(game.key), {...game, ...change}])))

  const toggleGame  = (key, checked) => setGames(games.map(g => g.key == key ? {...g, checked: checked} : g))

  const toggleRound = (round, checked) => setGames(games.map(g => g.round == round && !g.id ? {...g, checked: checked} : g))

  const updateField = (game, field_id) => updateGames(game, {field_id: field_id})

  const updateDate  = (game, date) => updateGames(game, {date: date.format('YYYY-MM-DD')})

  const updateTime  = (game, time) => updateGames(game, {time: time})

  const controlOpen = (type, key) => JSON.stringify(control) === JSON.stringify({type: type, key: key})

  const toggleControl = (type, game) => {
    if (type == 'time' && !control.type) loadTimeslots(game)

    setControl(control.type ? {} : {type: type, key: game.key})
  }

  const gamesList = (list, round) => {
    return list.map(game => {
      const team1 = teams.find(t => t.id == game.team1_id) 
      const team2 = teams.find(t => t.id == game.team2_id) 
      const field = fields.find(f => f.id == game.field_id)

      return <tr key={game.key}>
        <td onClick={() => setControl({})}>
          { game.id && <input type='checkbox' checked='1' disabled='1' /> }
          { !game.id &&
            <input type='checkbox'
              name={`create_${game.key}`}
              checked={game.checked}
              onChange={e => toggleGame(game.key, e.target.checked)} />
          }
        </td>
        <td className='width-date'>
          <div onClick={() => !game.id && toggleControl('date', game)}>
            {game.date}
            {!game.id && <img className='edit-marker' src='/images/leagues/edit-member.png' />}
          </div>
          { controlOpen('date', game.key) && 
            <div className='preview-dropdown'>
              <DatePicker className='preview-dropdown__datepicker'
                dateFormat='YYYY-MM-DD'
                onChange={date => updateDate(game, date)}
                onClickOutside={() => setControl({})}
                selected={moment(game.date)}
                inline
              />
            </div>
          }
        </td>
        <td className='width-time'>
          <div onClick={() => !game.id && toggleControl('time', game)}>
            {game.time}
            {!game.id && <img className='edit-marker' src='/images/leagues/edit-member.png' />}
          </div>
          { controlOpen('time', game.key) && 
            <div className='preview-dropdown'>
              <select className='preview-dropdown__select'
                value={game.time}
                onChange={e => updateTime(game, e.target.value)}>
                {!times.length && <option key={1} value={game.time}>{game.time}</option>}
                {times.length && times.map((time, i) => <option key={i} value={time}>{time}</option>)}
              </select>
            </div>
          }
        </td>
        <td onClick={() => setControl({})}>
          <div className='team-title'>
            <img src={imageUrl(team1)} />
            <div className='team-title__name'>{team1.name}</div>
          </div>
        </td>
        <td onClick={() => setControl({})}>
          <div className='team-title'>
            <img src={imageUrl(team2)} />
            <div className='team-title__name'>{team2.name}</div>
          </div>
        </td>
        <td className='width-field'>
          <div onClick={() => !game.id && toggleControl('field', game)}>
            {field.name}
            {!game.id && <img className='edit-marker' src='/images/leagues/edit-member.png' />}
          </div>
          { controlOpen('field', game.key) && 
            <div className='preview-dropdown'>
              <select className='preview-dropdown__select'
                value={field.id}
                onChange={e => updateField(game, e.target.value)}>
                {fields.map(f => <option key={f.id} value={f.id}>{f.name}</option>)}
              </select>
            </div>
          }
        </td>
      </tr>
    })
  }

  const gamesTable = (list, i) => {
    return <div className='games-table-wrap'>
      <div className='preview-round__header' onClick={() => setControl({})}>
        <input type='checkbox' name={`round_${i}`} onClick={e => toggleRound(i, e.target.checked)} />
        <div className='round-number'>
          Round {i}
        </div>
      </div>
      <table className='members-table'>
        <thead>
          <tr>
            <th></th>
            <th>DATE</th>
            <th>TIME</th>
            <th>TEAM 1</th>
            <th>TEAM 2</th>
            <th>FIELD</th>
          </tr>
        </thead>
        <tbody>
          {gamesList(list, i)}
        </tbody>
      </table>
    </div>
  }

  return <div className='preview'>
    <div className='step-section'>
      <div className='section-title'>Preview</div>
      {rounds.map(i => <div className='preview-round' key={i}>
        {gamesTable(games.filter(g => g.round == i), i)}
      </div>)}
    </div>

    <div className='button-section'>
      <button className='team-button back-button' onClick={onPrevStep}>Back</button>
      <button className='team-button next-button' type='submit'>Create</button>
    </div>
  </div>
}

export default Preview
